import { Font } from '@react-pdf/renderer';

/** Same Inter/Poppins families as the Google Fonts imports in `index.css`. */
const GOOGLE_FONT_FILES = {
  interRegular:
    'https://fonts.gstatic.com/s/inter/v20/UcCO3FwrK3iLTeHuS_nVMrMxCp50SjIw2boKoduKmMEVuLyfMZs.woff',
  interMedium:
    'https://fonts.gstatic.com/s/inter/v20/UcCO3FwrK3iLTeHuS_nVMrMxCp50SjIw2boKoduKmMEVuI6fMZs.woff',
  poppinsRegular: 'https://fonts.gstatic.com/s/poppins/v24/pxiEyp8kv8JHgFVrFJM.woff',
  poppinsMedium: 'https://fonts.gstatic.com/s/poppins/v24/pxiByp8kv8JHgFVrLGT9V1g.woff',
} as const;

Font.register({
  family: 'Inter',
  fonts: [
    { src: GOOGLE_FONT_FILES.interRegular, fontWeight: 400 },
    { src: GOOGLE_FONT_FILES.interMedium, fontWeight: 500 },
  ],
});

Font.register({
  family: 'Poppins',
  fonts: [
    { src: GOOGLE_FONT_FILES.poppinsRegular, fontWeight: 400 },
    { src: GOOGLE_FONT_FILES.poppinsMedium, fontWeight: 500 },
  ],
});

Font.registerHyphenationCallback((word: string): string[] => [word]);
